import {
  ErrorResponse,
  useCustomToast,
} from 'features/auth/hooks/use-custom-toast/use-custom-toast';
import { useGlobalMutation } from 'state/query-client/hooks';
import { getSignatureResponse } from 'pages/services/home-service';
import { useConfig } from 'hooks/use-config';

export const useSignatureResponse = () => {
  const { showErrorToast } = useCustomToast();
  const { configurationSettings } = useConfig();

  return useGlobalMutation({
    mutationKey: ['signatureResponse'],
    mutationFn: () => getSignatureResponse(configurationSettings),
    onError: ({ error }: ErrorResponse) => {
      showErrorToast(error);
    },
  });
};
